var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.07 40.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39,40.8,27.47,27.09,26,28.72l-8.67,3.19-.43-1c2.37-1.48,5-2.68,7.05-4.52,4.15-3.7,6.09-8.38,4.41-14a12.65,12.65,0,0,0-10.7-9.42C12.61,2.09,8.43,4,5.41,8.18A13,13,0,0,0,9.9,27.06c1.69.93,3.54,1.57,5.36,2.37-3.68,2-8.54.21-12.11-4.41A15.52,15.52,0,0,1,4.67,4.56c5.38-5.3,14.62-6.1,20.62-1.78,7.33,5.27,8.41,13.44,2.91,23.71L41,37.86C40.74,39.1,42.06,41.39,39,40.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying_glass.e775c4868f178151a5560c8663e8c48e.svg";
export { ForwardRef as ReactComponent };